import {Amplify, Logger, I18n} from '@aws-amplify/core'
import {Auth} from '@aws-amplify/auth'
import {AuthClass} from "@aws-amplify/auth/lib/Auth";
import Vue from "vue";
import Vuex from 'vuex'
import App from "./App.vue";
import aws_exports from "./aws-exports";
import { Hub } from '@aws-amplify/core';
import AmplifyStore from "./store/store";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faFileCode, faFileAlt, faTachometerAlt, faBookmark, faQuestion, 
  faSearch, faDownload, faUpload, faExclamationTriangle, faCheckCircle, faTimesCircle,
  faInfoCircle, faDatabase, faChartBar, faSync, faSpinner, faPlus, faMinus, faEdit,
  faTrash, faArrowLeft, faArrowRight, faCog, faHome, faSignOutAlt, faSignInAlt,
  faExternalLinkAlt, faClipboard, faQrcode, faFileExport, faLayerGroup
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/styles.scss';
import { LayoutPlugin, CardPlugin, ToastPlugin, ButtonPlugin, TablePlugin, FormPlugin, InputGroupPlugin, AlertPlugin,
  ModalPlugin, ProgressPlugin, FormInputPlugin, FormSelectPlugin, FormGroupPlugin, FormCheckboxPlugin, PaginationPlugin,
  FormDatepickerPlugin, CollapsePlugin, VBTogglePlugin, FormTextareaPlugin
} from 'bootstrap-vue'
import * as ToastHelper from './utilities/toastHelper'
import { dateFilters } from './utilities/dateFormatter'

// Apply AWS Configs
Amplify.configure(aws_exports)
Auth.configure(aws_exports)
I18n.configure(aws_exports)
Amplify.Auth = Auth
// Configure Amplify (aws-amplify-vue plugin removed as it's deprecated)

// Setup Font Awesome Library
library.add(faUserSecret, faFileCode, faFileAlt, faTachometerAlt, faBookmark, faQuestion,
  faSearch, faDownload, faUpload, faExclamationTriangle, faCheckCircle, faTimesCircle,
  faInfoCircle, faDatabase, faChartBar, faSync, faSpinner, faPlus, faMinus, faEdit,
  faTrash, faArrowLeft, faArrowRight, faCog, faHome, faSignOutAlt, faSignInAlt,
  faExternalLinkAlt, faClipboard, faQrcode, faFileExport, faLayerGroup)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

Vue.prototype.window = window;
Vue.prototype.$toast = ToastHelper;

// Register global date filters
Object.keys(dateFilters).forEach(key => {
  Vue.filter(key, dateFilters[key]);
});

// Vuex for data store
Vue.use(Vuex);
// Install BootstrapVue
Vue.use(CardPlugin)
Vue.use(ToastPlugin)
Vue.use(ButtonPlugin)
Vue.use(TablePlugin)
Vue.use(FormPlugin)
Vue.use(InputGroupPlugin)
Vue.use(AlertPlugin)
Vue.use(ModalPlugin)
Vue.use(ProgressPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(LayoutPlugin)
Vue.use(PaginationPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(CollapsePlugin)
Vue.use(VBTogglePlugin)
Vue.use(FormTextareaPlugin)

// Import our custom router. We're doing this here as the router import needs AWS to working.
import router from "./router";

let newVue = new Vue({
    router,
    render: h => h(App),
    components: {
        App
    }
}).$mount("#app");

ToastHelper.initialise(newVue.$bvToast)

// Setup authentication event listeners
function getUser() {
  return Auth.currentAuthenticatedUser()
    .then(data => {
      if (data && data.signInUserSession) {
        AmplifyStore.commit("setUser", data);
        return data;
      }
      return null;
    })
    .catch(() => {
      AmplifyStore.commit("setUser", null);
      return null;
    });
}

// Initialize user state
getUser();

// Listen for auth state changes using Hub
Hub.listen('auth', async ({ payload: { event } }) => {
  if (event === 'signOut') {
    AmplifyStore.commit("setUser", null);
  } else if (event === 'signIn') {
    await getUser();
  }
});


